import { FC, ReactNode } from 'react';

import { useRouter } from 'next/navigation';

import { ROUTES } from '@shared/constants/routes';
import { Button } from '@shared/ui/Button';

import cls from './Empty.module.scss';

type EmptyProps = {
  icon: ReactNode;
  title: ReactNode;
  description: ReactNode;
};

export const Empty: FC<EmptyProps> = ({ icon, title, description }) => {
  const { push } = useRouter();

  return (
    <div className={cls.wrap}>
      <div className={cls.icon}>{icon}</div>
      <h2 className={cls.title}>{title}</h2>
      <div className={cls.description}>{description}</div>
      <Button
        className={cls.button}
        size={'m'}
        onClick={() => push(ROUTES.MAIN)}
      >
        На главную
      </Button>
    </div>
  );
};
